import type { UseFormReturn } from "react-hook-form";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import type { ReminderEntityConfig } from "web_myplann/Reminders/Config/reminderEntityConfig";
import { applyReminderTemplateFormValues } from "web_myplann/Reminders/Forms/applyReminderTemplateFormValues";
import { getReminderTemplateFormValues } from "web_myplann/Reminders/Forms/getReminderTemplateFormValues";
import type { ReminderFormModel } from "web_myplann/Reminders/Forms/reminderFormSchema";
import type { ReminderTemplate } from "web_myplann/Reminders/Types/ReminderTypes";

export const useReminderTemplateSelection = (
	form: UseFormReturn<ReminderFormModel>,
	templates: ReminderTemplate[],
	entityConfig: ReminderEntityConfig,
	validTo: Date | null | undefined,
) => {
	const { t } = useResource();
	const { setValue } = form;

	const selectTemplate = (template: ReminderTemplate) => {
		applyReminderTemplateFormValues(
			setValue,
			getReminderTemplateFormValues(template, entityConfig, validTo, t),
			{ shouldValidate: true, shouldDirty: true },
		);
	};

	const markAsCustom = () => {
		if (!entityConfig.allowCustom) {
			return;
		}

		const customTypeKey = templates.find(
			(template) => template.isCustom,
		)?.typeKey;

		if (customTypeKey === undefined) {
			return;
		}

		setValue("typeKey", customTypeKey, {
			shouldValidate: true,
			shouldDirty: true,
		});
	};

	return { selectTemplate, markAsCustom };
};
